import Axios, { AxiosError } from 'axios';
import eventEmitter from '../utils/eventEmitter';
import { authApi } from './authApi'; // usaremos o authApi para tentar refresh do token

/**
 * Define a baseURL para o Synthesis.
 */
function mountBaseUrlSynthesis() {
  const env = process.env.NODE_ENV;
  if (env === 'development') {
    return 'http://localhost:8003/api';
  }
  return 'https://synthesis.publisol.com.br/api';
}

// Cria a instância do Axios para o Synthesis
const synthesisApi = Axios.create({
  baseURL: mountBaseUrlSynthesis(),
  withCredentials: true, // para enviar o cookie
});

// Interceptor de resposta – tenta refresh no 401
synthesisApi.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      originalRequest &&
      !(originalRequest as any)._retry
    ) {
      (originalRequest as any)._retry = true;
      try {
        await authApi.post('/token/refresh/');
        return synthesisApi(originalRequest);
      } catch (refreshError: any) {
        eventEmitter.emit('logout');
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export { synthesisApi };
